import { trackException } from './exceptionTracker';
import { resolveListgenUserID } from './resolveListgenUserID';

const listgenUserIDForLog = (agentData) => {
  if (agentData?.listgenUserID) {
    return String(agentData.listgenUserID);
  }
  return resolveListgenUserID() || undefined;
};

export const logFreshdeskTicketRejected = ({
  module,
  response,
  currentArea = {},
  hasAttachment = false,
  agentData,
}) => {
  trackException({
    module,
    code: 'TICKET_REJECTED',
    error: new Error('Failed to submit ticket'),
    httpStatus: response?.status,
    listgenUserID: listgenUserIDForLog(agentData),
    data: {
      mlsAreaID: currentArea.mlsAreaID,
      hasAttachment,
    },
  });
};

export const logFreshdeskSubmitFailed = ({
  module,
  error,
  currentArea = {},
  hasAttachment = false,
  httpStatus,
  agentData,
}) => {
  trackException({
    module,
    code: 'SUBMIT_FAILED',
    error,
    httpStatus,
    listgenUserID: listgenUserIDForLog(agentData),
    data: {
      mlsAreaID: currentArea.mlsAreaID,
      hasAttachment,
    },
  });
};

export const logFreshdeskValidationFailed = ({
  module,
  reason,
  currentArea = {},
  agentData,
}) => {
  trackException({
    module,
    code: 'VALIDATION_FAILED',
    error: new Error(reason),
    listgenUserID: listgenUserIDForLog(agentData),
    data: {
      mlsAreaID: currentArea.mlsAreaID,
      reason,
    },
  });
};
